var map = {
	"./subscribeDiscount.svg": 901,
	"./subscribeDiscount0.svg": 902,
	"./subscribeDiscount1.svg": 903,
	"./subscribeDiscount2.svg": 904,
	"./subscribeDiscount3.svg": 905
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 900;